module.exports = __webpack_public_path__ + "img/parsian.0b44bad3.png";